import { asGroupedFieldOptionsForFilter } from 'module/helpers/filter/grouped-field-transformer';
import { useTranslate } from 'module/hooks/use-translation';
import { GroupedFilter as GroupedFilterType } from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { ApiFilterTransformer } from 'module/ui/components/molecules/field-filter/filter-transformation/api-filter-transformer';
import { EmailPageTemplateUiState } from 'api/email-page-template/types';
import { PageType, SourceType, TiptapJson } from 'api/page-template/types';
import { useCompanyFieldsAsFilterableField } from 'helpers/fields/company-fields/fields';
import { useEmailFieldsAsFilterableField } from 'helpers/fields/email-fields/fields';
import { defaultContent } from './email-utils';
import { BaseTemplatePage } from '../shared/base-template';

export const EmailTemplatePage = ({
  templateData,
  onTemplateChange,
  groupedTransformer,
  previousTiptapJson,
  isModuleFed = false,
}: {
  templateData?: EmailPageTemplateUiState;
  onTemplateChange: (payload: Partial<EmailPageTemplateUiState>) => void;
  groupedTransformer?: ApiFilterTransformer<GroupedFilterType>;
  previousTiptapJson?: TiptapJson;
  isModuleFed?: boolean;
}) => {
  const { fields: companyFields } = useCompanyFieldsAsFilterableField();
  const { fields: emailFields } = useEmailFieldsAsFilterableField();

  const groupedFields = asGroupedFieldOptionsForFilter(
    {
      [FilterGroupType.Company]: {
        fields: companyFields,
      },
      [FilterGroupType.Email]: {
        fields: emailFields,
      },
    },
    useTranslate(),
  );

  return (
    <BaseTemplatePage<PageType.Email, SourceType.Email>
      pageType={PageType.Email}
      templateData={templateData}
      groupedFields={groupedFields}
      groupedTransformer={groupedTransformer}
      onTemplateChange={onTemplateChange}
      defaultContent={defaultContent}
      isModuleFed={isModuleFed}
      previousTiptapJson={previousTiptapJson}
    />
  );
};
